import { render } from "./LocationsDbCategoriesListModal.vue?vue&type=template&id=627de734&scoped=true&bindings={\"locationsDbCategories\":\"options\",\"close\":\"options\"}"
import script from "./LocationsDbCategoriesListModal.vue?vue&type=script&lang=js"
export * from "./LocationsDbCategoriesListModal.vue?vue&type=script&lang=js"

import "./LocationsDbCategoriesListModal.vue?vue&type=style&index=0&id=627de734&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-627de734"

export default script